import { Text } from "@react-pdf/renderer";

const TextType = ({ data }) => {
  return <Text>{data.content}</Text>;
};

export default TextType;
